export default {
  getAll: {
    url: '/api/permission/getAll',
    method: 'get'
  },
  create: {
    url: '/api/permission/create',
    method: 'post'
  },
  update: {
    url: '/api/permission/update',
    method: 'put'
  },
  delete: {
    url: '/api/permission/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/permission.js